// removed by extract-text-webpack-plugin
module.exports = {"roundTab":"_3BOtZyZs2CQEmtQNTR-ZDF","title":"_3clwPBk6PfcxOnysQuTgiC","num":"_2TQbT7XH4_Z37cm5Cqm6sZ","roundTabActive":"kDKhsmAF2eknYrsNj7_N0 _3BOtZyZs2CQEmtQNTR-ZDF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RoundTab/RoundTab.css
// module id = 179
// module chunks = 0